/*
  Business Card PDP behavior (product.business-card-pdp template)

  1. Relocates the Uploadly app block into the "Upload Your Own Artwork" panel.
  2. Relocates the PitchPrint button section into the "Use a Template" panel.
  3. When "Let Us Design For You" is selected, adds the design-fee product to the
     cart (with the contact-form answers as line item properties) before letting
     the theme's normal add-to-cart flow run for the main product.
*/
(function () {
  'use strict';

  var RELOCATE_TIMEOUT_MS = 30000;
  var RELOCATE_POLL_MS = 300;

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  /* Poll for an element until found (or timeout), then run callback. */
  function waitFor(getter, callback) {
    var elapsed = 0;
    var timer = setInterval(function () {
      var el = getter();
      if (el) {
        clearInterval(timer);
        callback(el);
      } else if ((elapsed += RELOCATE_POLL_MS) >= RELOCATE_TIMEOUT_MS) {
        clearInterval(timer);
      }
    }, RELOCATE_POLL_MS);
  }

  function getSelectedDesign(selector) {
    var checked = selector.querySelector('input[data-bc-design-option]:checked');
    return checked ? checked.value : 'template';
  }

  /* ---- Part 2: Uploadly relocation ---- */
  function relocateUploadly(selector) {
    var slot = selector.querySelector('[data-bc-uploadly-slot]');
    if (!slot) return;
    waitFor(
      function () {
        var el = document.querySelector(
          '.m-main-product div[id^="shopify-block-"][id*="uploadly"]'
        );
        // Wait until the app has actually rendered its upload UI inside the block
        return el && el.childElementCount > 0 ? el : null;
      },
      function (el) {
        slot.appendChild(el);
        el.classList.add('bc-relocated');
      }
    );
  }

  /* ---- Part 3: PitchPrint relocation ---- */
  function relocatePitchPrint(selector) {
    var slot = selector.querySelector('[data-bc-pitchprint-slot]');
    if (!slot) return;
    waitFor(
      function () {
        return document.getElementById('pp_main_btn_sec');
      },
      function (el) {
        slot.appendChild(el);
        el.classList.add('bc-relocated');
      }
    );
  }

  /* ---- Part 4: design-fee line item ---- */
  function collectProperties(selector) {
    var properties = {};
    var productTitle = selector.getAttribute('data-product-title');
    if (productTitle) properties['For Product'] = productTitle;
    selector.querySelectorAll('[data-bc-property]').forEach(function (field) {
      var value = (field.value || '').trim();
      if (value) properties[field.getAttribute('data-bc-property')] = value;
    });
    return properties;
  }

  function validateCustomFields(selector) {
    var valid = true;
    var firstInvalid = null;
    selector.querySelectorAll('[data-bc-required]').forEach(function (field) {
      if ((field.value || '').trim() === '') {
        field.classList.add('bc-invalid');
        if (!firstInvalid) firstInvalid = field;
        valid = false;
      } else {
        field.classList.remove('bc-invalid');
      }
    });
    var error = selector.querySelector('[data-bc-form-error]');
    if (error) error.hidden = valid;
    if (firstInvalid) firstInvalid.focus();
    return valid;
  }

  function addFeeProduct(selector) {
    var feeVariantId = parseInt(selector.getAttribute('data-fee-variant-id'), 10);
    return fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [
          {
            id: feeVariantId,
            quantity: 1,
            properties: collectProperties(selector),
          },
        ],
      }),
    }).then(function (response) {
      if (!response.ok) {
        return response.json().then(function (data) {
          throw new Error((data && data.description) || 'Could not add the design service to the cart.');
        });
      }
      return response.json();
    });
  }

  function bindAddToCart(selector) {
    var feeVariantId = parseInt(selector.getAttribute('data-fee-variant-id'), 10);
    if (!feeVariantId) return;

    // Capture on document so this runs before the theme's product-form submit
    // handler, which is bound directly on the form element.
    document.addEventListener(
      'submit',
      function (evt) {
        var form = evt.target;
        if (!form.matches || !form.matches('form[data-type="add-to-cart-form"]')) return;
        if (form.dataset.bcFeePending === 'done') {
          delete form.dataset.bcFeePending;
          return; // re-dispatched submit: let the theme handle the main product
        }
        if (getSelectedDesign(selector) !== 'custom') return;

        evt.preventDefault();
        evt.stopImmediatePropagation();

        if (!validateCustomFields(selector)) return;

        var submitButton = form.querySelector('[name="add"]');
        if (submitButton) submitButton.classList.add('m-spinner-loading');

        addFeeProduct(selector)
          .then(function () {
            form.dataset.bcFeePending = 'done';
            if (typeof form.requestSubmit === 'function') {
              form.requestSubmit();
            } else {
              form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
            }
          })
          .catch(function (error) {
            var errorBox = selector.querySelector('[data-bc-form-error]');
            if (errorBox) {
              errorBox.textContent = error.message;
              errorBox.hidden = false;
            }
          })
          .finally(function () {
            if (submitButton) submitButton.classList.remove('m-spinner-loading');
          });
      },
      true
    );
  }

  function bindFieldCleanup(selector) {
    selector.addEventListener('input', function (evt) {
      if (evt.target.matches && evt.target.matches('[data-bc-required]')) {
        if ((evt.target.value || '').trim() !== '') evt.target.classList.remove('bc-invalid');
      }
    });
  }

  ready(function () {
    var selector = document.querySelector('[data-bc-design-selector]');
    if (!selector) return;

    relocateUploadly(selector);
    relocatePitchPrint(selector);
    bindAddToCart(selector);
    bindFieldCleanup(selector);
  });
})();
